export default {
    checkPower: function (myPowers, needPowers) {
        return true;
        if (!myPowers || !Array.isArray(myPowers) || myPowers.length <= 0) {
            return false;
        }
        if (!needPowers || !Array.isArray(needPowers) || needPowers.length <= 0) {
            return true;
        }
        for (let needPower of needPowers) {
            if (Array.isArray(needPower)) {
                let need = needPower.filter(function (power) {
                    return myPowers.includes(power);
                });
                if (need.length <= 0) {
                    return false;
                }
            } else {
                if (!myPowers.includes(needPower)) {
                    return false;
                }
            }
        }
        return true;
    }
};



// WEBPACK FOOTER //
// ./src/helper.js